<template>
  <system-update-info :detail="detail" />
</template>

<script>
import SystemUpdateInfo from "@/components/dashboard/devops/version/system-update/index.vue";
import { reactive } from "vue";
export default {
  components: {
    [SystemUpdateInfo.name]: SystemUpdateInfo
  },
  setup() {
    const detail = reactive({
      currentVersion: "TacOS Enterprise  22Q1",
      updateTime: "2022/03/19  14:00:33",
      updateVersion: "TacOS Enterprise  22Q2",
      total: 5,
      items: [
        "system-kernel",
        "system-space-modle v1.2.1",
        "system-space-studioV1.2.3",
        "system-pannel v1.1.1",
        "system-pannel v1.1.1"
      ]
    });
    return {
      detail
    };
  }
};
</script>
